module.exports = __webpack_public_path__ + "images/feature/calendar-todo-2-3fa78f5f6d008184498f859ed158e10b.png";